import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
export const ProtectedRoute = ({ children, redirectTo = '/login', authResult }) => {
    const location = useLocation();
    const { currentUser, loading, isAuthorized, profiles = [] } = authResult;
    if (loading) {
        return (_jsx(Box, { sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }, children: _jsx(CircularProgress, {}) }));
    }
    if (!currentUser) {
        // Not logged in at all, redirect to login
        return _jsx(Navigate, { to: redirectTo, state: { from: location }, replace: true });
    }
    if (!isAuthorized) {
        // User doesn't have required access
        // Only redirect to registration if they have no profiles
        if (profiles.length === 0) {
            console.log('No profiles found, redirecting to registration');
            return _jsx(Navigate, { to: "/register", state: { from: location }, replace: true });
        }
        // If they have profiles but still not authorized, redirect to login
        return _jsx(Navigate, { to: redirectTo, state: { from: location }, replace: true });
    }
    // User is authenticated and authorized, render the protected content
    return _jsx(_Fragment, { children: children });
};
